import {get, post, put} from '@/api';
import * as DOCTOR from '../constants/doctor';
import queryString from 'query-string';

export default {
  /**
   * Doctor list.
   *
   * @param commit
   * @param param
   * @returns {PromiseLike<T> | Promise<T> | *}
   */
  [DOCTOR.ACTION_LIST_DOCTORS]: ({commit}, param) => {
    const qs = queryString.stringify(param, {arrayFormat: 'bracket'});
    return get(`/doctor?${qs}`).then((res) => {
      commit(DOCTOR.MUTATE_LIST_DOCTOR, res.data);
    })
  },

  /**
   * Add doctor
   *
   * @param commit
   * @param payload
   * @returns {*}
   */
  [DOCTOR.ACTION_ADD]: ({commit}, payload) => {
    return post(`/doctor`, payload);
  },

  /**
   * Edit doctor.
   *
   * @param commit
   * @param id
   * @param payload
   * @returns {*}
   */
  [DOCTOR.ACTION_EDIT]: ({commit}, {id, payload}) => {
    return put(`/doctor/${id}`, payload);
  },

  /**
   * Update doctor
   * @param commit
   * @param id
   * @param payload
   * @returns {*}
   */
  [DOCTOR.ACTION_UPDATE]: ({commit}, {id, payload}) => {
    return put(`/doctor/${id}`, payload);
  },
}


// WEBPACK FOOTER //
// ./src/store/doctor/actions.js